export const LanguagesConstants = {
    GET_LANGUAGES_REQUEST: 'GET_LANGUAGES_REQUEST',
    GET_LANGUAGES_SUCCESS: 'GET_LANGUAGES_SUCCESS',
    GET_LANGUAGES_FAILURE: 'GET_LANGUAGES_FAILURE',
    
}


// WEBPACK FOOTER //
// ./src/store/constants/languages.constants.js